


























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { DxButton, DxScrollView, DxTextBox, DxTooltip, DxLoadIndicator } from 'devextreme-vue';
import DxTabPanel from 'devextreme-vue/tab-panel';
import { CellPreparedEvent } from 'devextreme/ui/data_grid';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { prettyCell, setAlternatingRowsBackground } from '@/utils/excel';

import TableGrid from '@/components/TableGrid/grid.vue';
import DButton from '@/components/DButton/button.vue';
import BalanceHeaderSet from '@/components/HeaderSet/BalanceHeaderSet.vue';

import BalanceService, { Grouping, totalCaptionObject } from '@/services/balance-service';
import DictsCacheService from "@/services/dicts_cache_service";
import YearService from '@/services/years-service';
import EcoObjectsService from '@/services/eco-objects-service';
import { saveAs } from 'file-saver';
import getGridInstance from "@/utils/grid-instance";
import { on } from 'devextreme/events';
import { format2DigitsVariant, format3DigitsVariant, format5DigitsVariant } from '@/utils/numbers';
import { FilialNodeItem } from '@/services/models-service';
import {getImbalanceStyleColor} from "@/utils/getImbalanceStyleColor";
import FullNumberTooltip from '@/directives/full-number-tooltip';
import { aggregate_periods } from '@/constants';

let letters = '0abcdefghijkl';

@Component({
  name: 'Balance',
  components: {
    DxTabPanel,
    DxLoadIndicator,
    DxButton,
    DxTextBox,
    DxTooltip,
    TableGrid,
    DxScrollView,
    DButton,
    BalanceHeaderSet,
  }
})

export default class extends Vue {

  public selectedTabIndex: number = 0;
  private selectedTabKey: string = 'main';

  private service = BalanceService;

  private columns: any[] = [];
  private groupedColumns: any[] = [];
  private summary: any = {};

  private currentGrouping = Grouping.BY_PERIOD;

  public ecoService = EcoObjectsService;

  public showPlug: boolean = true;
  public filtersSelected: boolean = false;

  public showLoadIndicator: boolean = false;

  public currentImbalanceValue = '0,00000';

  public isLoad: boolean = false;
  public current_cut: any = null;
  public current_filial: number | null = null;
  public current_node: number | null = null;
  public current_facility: number | null = null;
  public all_filials: any[] = [];
  public all_filials_tree: any = {};
  public all_facilities: any[] = [];

  private precisionValue = 3;

  private widgetCount = 1;
  private readyCtr = 0;

  public transformedDataGrid: any = null;
  public transformedDataGridCompare: any = null;
  public deviationDataProcessed: any = null;
  public gropedObj: any = null;

  private cutNames = {
    name: "",
    secondary: ""
  }

  public selectedObjects: string[] = [""];

  public on_display_internal_revolutions: boolean = false;

  private scrollSyncEnabled: boolean = false;
  private isScrolling: boolean = false;
  private scrollHandlers: Array<() => void> = [];
  private deviationUpdateTimeout: any = null;

  public selectionReal: any = {}

  get tabs() {
    const items: Array<{ key: string; title: string; header: string; disabled?: boolean }> = [];

    items.push({
      key: 'main',
      title: (this.cutNames?.name) || 'Основная срезка',
      header: (this.cutNames?.name) || ''
    });

    if (this.showCompareCut) {
      items.push({
        key: 'compare',
        title: (this.cutNames?.secondary) || 'Сравнение',
        header: (this.cutNames?.secondary) || ''
      });
      if (this.service?.current?.show_deviation) {
        items.push({ key: 'deviation', title: 'Отклонение', header: 'Отклонение' });
      }
    }

    return items;
  }
  onSelectionRealChanged(selection: any) {
    this.selectionReal = selection;
    console.log('selectionReal', this.selectionReal);
  }

  @Watch('tabs')
  onTabsChanged(newTabs: Array<{ key: string; disabled?: boolean }>, oldTabs: Array<{ key: string; disabled?: boolean }>) {
    let idx = newTabs.findIndex(t => t.key === this.selectedTabKey);
    if (idx === -1) {
      this.selectedTabKey = 'main';
      idx = newTabs.findIndex(t => t.key === 'main');
    }

    if (newTabs[idx]?.disabled) {
      idx = newTabs.findIndex(t => !t.disabled);
      this.selectedTabKey = newTabs[Math.max(0, idx)]?.key || 'main';
    }

    this.selectedTabIndex = Math.max(0, idx);
  }

  get tableHeaderTitle() {
    if (this.selectedObjects.length > 1) {
      return 'Итого по выбранной группе объектов';
    } else {
      return `Объект ${this.selectedObjects[0]}`;
    }
  }

  onDisplayInternalRevolutions(data: boolean) {
    this.on_display_internal_revolutions = data
  }

  onSelectedObjectsChanged(selected: string[]) {
    this.selectedObjects = selected;
  }

  onSelectedGroupedObjectChanged(selected: string[]) {
    this.service.selectedGroupedObject = selected;
  }

  async getFilialsTree() {
    if (!this.current_cut) {
      return;
    }

    this.all_filials = [];
    this.all_filials_tree = {};
  }

  saveFilters() {
  }

  async mounted() {
    this.initColumns();
    this.initGroupedColumns();
  }

  beforeDestroy() {
    this.cleanupScrollHandlers();
    if (this.deviationUpdateTimeout) {
      clearTimeout(this.deviationUpdateTimeout);
    }
  }

  get balance() {
    if (this.currentGrouping === Grouping.BY_FACILITY) {
      return this.service.balanceByObj;
    }
    if (this.service.current.show_selected_nodes_facility) {
      return this.service.balance;
    } else {
      return this.service.balanceNodes;
    }
  }

  get balanceCompare() {
    if (!this.showCompareCut) {
      return []
    }
    return this.transformedDataGridCompare || [];
  }

  get showCompareCut() {
    return this.service.current.show_compare_cut && this.service.current.id_compare_cut
  }

  get balanceGrid() {
    if (this.service.current.id_cut)
      return getGridInstance(this.$refs.balanceGrid);
  }

  get balanceCompareGrid() {
    if (this.showCompareCut)
      return getGridInstance(this.$refs.balanceCompareGrid);
  }

  get balanceDeviationGrid() {
    if (this.showCompareCut && this.service.current.show_deviation)
      return getGridInstance(this.$refs.balanceDeviationGrid);
  }

  get groupedBalanceGrid() {
    if (this.service.groupedBalanceObj.length > 0) {
      return this.service.groupedBalanceObj;
    }
  }

  get period_ds() {
    const periods = DictsCacheService.periods.filter((p: any) => p.months.length === 1).map((p1: any) => {
      return {...p1, months: p1.months[0]}
    });
    periods.push({display: 'Год', months: 13, name: 'year'});
    return periods;
  }

  get nodes_ds() {
    if (!Object.keys(this.ecoService.filialNodesTree).length) {
      return [];
    }
    let result: any[] = [];
    for (const value of Object.values(this.ecoService.filialNodesTree)) {
      for (const nodeObj of Object.values<FilialNodeItem>(value)) {
        result.push({id: nodeObj.id, name: nodeObj.name, weight: '2'})
      }
    }
    return result;
  }

  get composite_ds() {
    return [
      totalCaptionObject
    ].concat(this.nodes_ds);
  }

  @Watch('service.balance')
  onBalanceChanged() {
    this.rebuildTransformedDataGrid();
  }

  @Watch('service.groupedBalanceObj')
  onGroupedBalanceChanged() {
    this.gropedObj = [];
    this.gropedObj = this.getAggregatedRows(this.getTranformGroupedBalanceObj());
    this.transformedDataGrid = this.mergeDataWithGrouped(this.transformedDataGrid);
  }

  @Watch('service.balanceCompare')
  onBalanceCompareChanged() {
    this.transformedDataGridCompare = this.getAggregatedRows(this.getTranformedDataGridBalanceCompare())
    this.scheduleDeviationUpdate();
  }

  @Watch('transformedDataGrid')
  onTransformedDataGridChanged() {
    this.scheduleDeviationUpdate();
  }

  private scheduleDeviationUpdate() {
    if (this.deviationUpdateTimeout) {
      clearTimeout(this.deviationUpdateTimeout);
    }
    
    this.deviationUpdateTimeout = setTimeout(() => {
      this.updateDeviation();
      this.deviationUpdateTimeout = null;
    }, 300);
  }

  private updateDeviation() {
    if (!this.showCompareCut || !this.service.current.show_deviation) {
      this.deviationDataProcessed = null;
      return;
    }

    if (this.service.isBalanceLoading) {
      return;
    }

    if (!this.transformedDataGrid || !this.transformedDataGridCompare) {
      this.deviationDataProcessed = null;
      return;
    }

    this.deviationDataProcessed = this.calculateDeviation();
  }

  private calculateDeviation(): any[] {
    if (!this.transformedDataGrid || !this.transformedDataGridCompare) {
      return [];
    }

    const compareMap = new Map<string, any>();
    this.transformedDataGridCompare.forEach((compareRow: any) => {
      const key = `${compareRow.id_eco_heat_node}|${compareRow.month}|${compareRow.facility_name}`;
      compareMap.set(key, compareRow);
    });

    const result: any[] = [];
    const processedKeys = new Set<string>();

    this.transformedDataGrid.forEach((mainRow: any) => {
      const key = `${mainRow.id_eco_heat_node}|${mainRow.month}|${mainRow.facility_name}`;
      const compareRow = compareMap.get(key);
      
      processedKeys.add(key);
      result.push(this.createDeviationRow(mainRow, compareRow || null));
    });

    this.transformedDataGridCompare.forEach((compareRow: any) => {
      const key = `${compareRow.id_eco_heat_node}|${compareRow.month}|${compareRow.facility_name}`;
      if (!processedKeys.has(key)) {
        result.push(this.createDeviationRow(null, compareRow));
      }
    });

    return result;
  }

  private createDeviationRow(mainRow: any | null, compareRow: any | null): any {
    const mainData = mainRow || compareRow;
    
    return {
      id_eco_heat_node: mainData?.id_eco_heat_node,
      node_name: mainData?.node_name,
      facility_name: mainData?.facility_name,
      month: mainData?.month,
      is_total_node: mainData?.is_total_node,
      grouped_object: mainData?.grouped_object,
      display_order: mainData?.display_order,
      
      steam: this.calculateRowDifference(mainRow?.steam, compareRow?.steam),
      system_water: this.calculateRowDifference(mainRow?.system_water, compareRow?.system_water),
      
      imbalance: (mainRow?.imbalance ?? 0) - (compareRow?.imbalance ?? 0),
      imbalance_steam: (mainRow?.imbalance_steam ?? 0) - (compareRow?.imbalance_steam ?? 0),
      imbalance_water: (mainRow?.imbalance_water ?? 0) - (compareRow?.imbalance_water ?? 0),
    };
  }

  private calculateRowDifference(mainData: any, compareData: any): any {
    const result: any = {};

    if (!mainData && !compareData) {
      return result;
    }

    const allKeys = new Set([
      ...(mainData ? Object.keys(mainData) : []),
      ...(compareData ? Object.keys(compareData) : [])
    ]);

    allKeys.forEach(key => {
      const mainValue = mainData?.[key] ?? 0;
      const compareValue = compareData?.[key] ?? 0;
      result[key] = mainValue - compareValue;
    });

    return result;
  }

  getAggregatedRows(flatData: any[] | null) {
    const selectedPeriods = this.service.current.period || [];

    const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 
                      'july', 'august', 'september', 'october', 'november', 'december'];
    
    const aggregatedPeriods = selectedPeriods.filter((p: string) => 
      !monthNames.includes(p) && aggregate_periods[p]
    );
    
    if (aggregatedPeriods.length === 0) {
      return flatData;
    }
    if (!flatData) {
      return null;
    }

    const result: any[] = [];
    
    const groupedByNodeAndFacility: Record<string, any[]> = {};
    
    for (const row of flatData) {
      const nodeId = row.id_eco_heat_node || 'total';
      const facilityName = row.facility_name || '';
      const key = `${nodeId}|${facilityName}`;
      
      if (!groupedByNodeAndFacility[key]) {
        groupedByNodeAndFacility[key] = [];
      }
      groupedByNodeAndFacility[key].push(row);
    }
    
    for (const [key, rows] of Object.entries(groupedByNodeAndFacility)) {
      result.push(...rows);
      
      for (const aggPeriod of aggregatedPeriods) {
        const monthsInPeriod = aggregate_periods[aggPeriod];
        
        const relevantRows = rows.filter((row: any) => 
          monthsInPeriod.includes(row.month)
        );
        
        if (relevantRows.length === 0) {
          continue;
        }
        
        const aggregatedRow: any = {
          id_eco_heat_node: relevantRows[0].id_eco_heat_node,
          node_name: relevantRows[0].node_name,
          facility_name: relevantRows[0].facility_name,
          month: aggPeriod,
          imbalance: 0,
          imbalance_steam: 0,
          imbalance_water: 0,
          system_water: {},
          steam: {},
          is_total_node: relevantRows[0].is_total_node,
          grouped_object: relevantRows[0].grouped_object,
          display_order: relevantRows[0].display_order
        };
        
        for (const row of relevantRows) {
          aggregatedRow.imbalance += row.imbalance ?? 0;
          aggregatedRow.imbalance_steam += row.imbalance_steam ?? 0;
          aggregatedRow.imbalance_water += row.imbalance_water ?? 0;
          
          for (const fieldKey of Object.keys(row.system_water ?? {})) {
            aggregatedRow.system_water[fieldKey] = 
              (aggregatedRow.system_water[fieldKey] || 0) + (row.system_water?.[fieldKey] ?? 0);
          }
          
          for (const fieldKey of Object.keys(row.steam ?? {})) {
            aggregatedRow.steam[fieldKey] = 
              (aggregatedRow.steam[fieldKey] || 0) + (row.steam?.[fieldKey] ?? 0);
          }
        }
        
        result.push(aggregatedRow);
      }
    }
    
    return result;
  }

  private mergeDataWithGrouped(regularData: any[] | null): any[] {
    if (!regularData && !this.gropedObj) {
      return [];
    }

    if (!regularData || regularData.length === 0) {
      if (this.gropedObj && Array.isArray(this.gropedObj) && this.gropedObj.length > 0) {
        return this.gropedObj;
      }
      return [];
    }

    if (this.gropedObj && Array.isArray(this.gropedObj) && this.gropedObj.length > 0) {
      // Фильтруем итоговые строки из regularData
      const nonTotalData = regularData.filter(item => !(item.is_total_node && item.display_order === 1));
      
      // Объединяем все данные без итогов
      const allData = [
        ...nonTotalData,
        ...this.gropedObj
      ];
      
      // Сортируем по display_order и месяцу (как в getTranformedDataGridBalance)
      // Порядок: 1 - Групповые объекты, 2 - Филиалы, 3 - Узлы, 4 - Объекты
      allData.sort((a, b) => {
        const orderA = a.display_order ?? 999;
        const orderB = b.display_order ?? 999;
        if (orderA !== orderB) {
          return orderA - orderB;
        }
        // Если display_order одинаковый, сортируем по названию для одинаковых типов
        const nameA = (a.facility_name || '').toLowerCase();
        const nameB = (b.facility_name || '').toLowerCase();
        if (nameA !== nameB) {
          return nameA.localeCompare(nameB, 'ru');
        }
        // Если названия одинаковые, сортируем по месяцу
        const monthOrder = this.periodOrder[a.month] ?? 999;
        const monthOrderB = this.periodOrder[b.month] ?? 999;
        return monthOrder - monthOrderB;
      });
      
      return allData;
    }

    // Фильтруем итоговые строки из regularData
    return regularData.filter(item => !(item.is_total_node && item.display_order === 1));
  }

  private aggregateGroupedIntoTotals(totals: any[], groupedData: any[]): any[] {
    if (totals.length === 0) {
      // Если нет существующих итогов, создаём новые
      return this.calculateCombinedTotals(groupedData);
    }

    // Группируем итоги по месяцам
    const totalsByMonth: Record<string, any> = {};
    for (const total of totals) {
      totalsByMonth[total.month] = { ...total };
    }

    // Агрегируем данные из групповых объектов
    for (const grouped of groupedData) {
      const month = grouped.month;
      
      if (!totalsByMonth[month]) {
        totalsByMonth[month] = {
          id_eco_heat_node: 'total',
          node_name: 'Итого по выбранной группе объектов',
          facility_name: 'Итого',
          month,
          imbalance: 0,
          imbalance_steam: 0,
          imbalance_water: 0,
          system_water: {},
          steam: {},
          is_total_node: true,
          display_order: 1
        };
      }

      const total = totalsByMonth[month];
      total.imbalance += grouped.imbalance ?? 0;
      total.imbalance_steam += grouped.imbalance_steam ?? 0;
      total.imbalance_water += grouped.imbalance_water ?? 0;

      for (const k of Object.keys(grouped.system_water ?? {})) {
        total.system_water[k] = (total.system_water[k] || 0) + (grouped.system_water?.[k] ?? 0);
      }
      for (const k of Object.keys(grouped.steam ?? {})) {
        total.steam[k] = (total.steam[k] || 0) + (grouped.steam?.[k] ?? 0);
      }
    }

    return Object.values(totalsByMonth);
  }

  private calculateCombinedTotals(rows: any[]): any[] {
    const totalsByMonth: Record<string, any> = {};

    for (const row of rows) {
      const month = row.month;
      if (!totalsByMonth[month]) {
        totalsByMonth[month] = {
          id_eco_heat_node: 'total',
          node_name: 'Итого по выбранной группе объектов',
          facility_name: 'Итого',
          month,
          imbalance: 0,
          imbalance_steam: 0,
          imbalance_water: 0,
          system_water: {},
          steam: {},
          is_total_node: true,
          display_order: 1
        };
      }

      const total = totalsByMonth[month];
      total.imbalance += row.imbalance ?? 0;
      total.imbalance_steam += row.imbalance_steam ?? 0;
      total.imbalance_water += row.imbalance_water ?? 0;

      for (const k of Object.keys(row.system_water ?? {})) {
        total.system_water[k] = (total.system_water[k] || 0) + (row.system_water?.[k] ?? 0);
      }
      for (const k of Object.keys(row.steam ?? {})) {
        total.steam[k] = (total.steam[k] || 0) + (row.steam?.[k] ?? 0);
      }
    }

    return Object.values(totalsByMonth);
  }

  private rebuildTransformedDataGrid() {
    const regularData = this.getAggregatedRows(this.getTranformedDataGridBalance());
    const merged = this.mergeDataWithGrouped(regularData);
    // Дополнительная сортировка для гарантии правильного порядка
    // Порядок: 1 - Групповые объекты, 2 - Филиалы, 3 - Узлы, 4 - Объекты
    merged.sort((a, b) => {
      const orderA = a.display_order ?? 999;
      const orderB = b.display_order ?? 999;
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      // Если display_order одинаковый, сортируем по названию
      const nameA = (a.facility_name || '').toLowerCase();
      const nameB = (b.facility_name || '').toLowerCase();
      if (nameA !== nameB) {
        return nameA.localeCompare(nameB, 'ru');
      }
      // Если названия одинаковые, сортируем по месяцу
      const monthOrder = this.periodOrder[a.month] ?? 999;
      const monthOrderB = this.periodOrder[b.month] ?? 999;
      return monthOrder - monthOrderB;
    });
    this.transformedDataGrid = merged;
  }

  private getFilialName(filialId: number): string {
    const tree = this.ecoService.filialNodesFacilitiesTree;
    if (!tree || !tree[filialId]) {
      return 'Неизвестный филиал';
    }
    return tree[filialId].name || 'Неизвестный филиал';
  }

  private getNodeName(nodeId: number): string {
    const node = this.nodes_ds.find(n => n.id === nodeId);
    return node?.name || 'Неизвестный узел';
  }

  private getFacilityName(facilityId: number): string {
    // Ищем название объекта в данных баланса
    const facility = this.service.balance?.find((item: any) => item.id_eco_facility === facilityId);
    return facility?.facility_name || 'Неизвестный объект';
  }

  private aggregateRowsByMonth(rows: any[]): Record<string, any> {
    const aggregated: Record<string, any> = {};
    
    for (const row of rows) {
      const month = row.month;
      if (!aggregated[month]) {
        aggregated[month] = {
          month,
          imbalance: 0,
          imbalance_steam: 0,
          imbalance_water: 0,
          system_water: {},
          steam: {}
        };
      }
      
      const agg = aggregated[month];
      agg.imbalance += row.imbalance ?? 0;
      agg.imbalance_steam += row.imbalance_steam ?? 0;
      agg.imbalance_water += row.imbalance_water ?? 0;
      
      for (const k of Object.keys(row.system_water ?? {})) {
        agg.system_water[k] = (agg.system_water[k] || 0) + (row.system_water?.[k] ?? 0);
      }
      
      for (const k of Object.keys(row.steam ?? {})) {
        agg.steam[k] = (agg.steam[k] || 0) + (row.steam?.[k] ?? 0);
      }
    }
    
    return aggregated;
  }

  getTranformGroupedBalanceObj() {
    if (!this.service.groupedBalanceObj || this.service.groupedBalanceObj.length === 0) {
      return null;
    }

    // Преобразуем групповые объекты в единый формат с префиксом
    const result = this.service.groupedBalanceObj.map((item: any) => ({
      ...item,
      facility_name: `Групповой объект: ${item.title}`,
      grouped_object: true,
      display_order: 1,
      sort_order: 1 // Скрытое поле для сортировки
    }));

    return result;
  }

  getTranformedDataGridBalance(): any {
    if (!this.service.balance || this.service.balance.length === 0) {
      return [];
    }
    console.log('this.service.balance', this.service.balance);

    if (!this.selectionReal || (!this.selectionReal.t_plus && !this.selectionReal.filials?.length && !this.selectionReal.nodes?.length && !this.selectionReal.facilities?.length)) {
      return [];
    }

    const result: any[] = [];
    const tree = this.ecoService.filialNodesFacilitiesTree;
    const selectedFilials = this.selectionReal?.filials || [];
    const selectedNodes = this.selectionReal?.nodes || [];
    const selectedFacilities = this.selectionReal?.facilities || [];

    // 1. Обрабатываем выбранные филиалы
    if (selectedFilials.length > 0) {
      for (const filialId of selectedFilials) {
        const filialName = this.getFilialName(filialId);
        
        // Находим все узлы этого филиала
        const filialData = tree?.[filialId];
        if (!filialData || !filialData.nodes) continue;
        
        // Собираем все объекты всех узлов филиала для агрегации
        const filialRows: any[] = [];
        for (const nodeIdStr in filialData.nodes) {
          const nodeId = Number(nodeIdStr);
          const nodeRows = this.service.balance.filter((row: any) => row.id_eco_heat_node === nodeId);
          filialRows.push(...nodeRows);
        }
        
        // Агрегируем по месяцам и показываем агрегированную запись филиала
        const aggregated = this.aggregateRowsByMonth(filialRows);
        for (const [month, data] of Object.entries(aggregated)) {
          result.push({
            facility_name: `Филиал: ${filialName}`,
            month,
            ...data,
            display_order: 2
          });
        }

        // Обрабатываем узлы из selectionReal.nodes, которые входят в этот филиал
        for (const nodeId of selectedNodes) {
          if (!filialData.nodes[nodeId]) continue; // Узел не входит в этот филиал
          
          const nodeName = this.getNodeName(nodeId);
          const nodeRows = this.service.balance.filter((row: any) => row.id_eco_heat_node === nodeId);
          
          // Показываем агрегированную запись узла (по всем объектам)
          const nodeAggregated = this.aggregateRowsByMonth(nodeRows);
          for (const [month, data] of Object.entries(nodeAggregated)) {
            result.push({
              facility_name: `ТУ: ${nodeName}`,
              month,
              ...data,
              display_order: 3
            });
          }

          // Показываем объекты из selectionReal.facilities, которые входят в этот узел
          // Используем Set для избежания дубликатов facilityId
          const nodeFacilityIdsSet = new Set<number>();
          for (const row of nodeRows) {
            if (selectedFacilities.includes(row.id_eco_facility)) {
              nodeFacilityIdsSet.add(row.id_eco_facility);
            }
          }
          const nodeFacilities = Array.from(nodeFacilityIdsSet);

          for (const facilityId of nodeFacilities) {
            const facilityRows = nodeRows.filter((row: any) => row.id_eco_facility === facilityId);
            for (const row of facilityRows) {
              result.push({
                facility_name: `Объект: ${row.facility_name || this.getFacilityName(facilityId)}`,
                month: row.month,
                imbalance: row.imbalance ?? 0,
                imbalance_steam: row.imbalance_steam ?? 0,
                imbalance_water: row.imbalance_water ?? 0,
                system_water: row.system_water ? { ...row.system_water } : {},
                steam: row.steam ? { ...row.steam } : {},
                display_order: 4
              });
            }
          }
        }

        // Обрабатываем объекты из selectionReal.facilities, которые входят в этот филиал, но не в выбранные узлы
        for (const facilityId of selectedFacilities) {
          const facilityRows = this.service.balance.filter((row: any) => row.id_eco_facility === facilityId);
          if (facilityRows.length === 0) continue;

          // Объект ЕСО может в течение периода поменять тепловой узел - тогда его
          // строки принадлежат разным узлам (см. п. 231/222 реестра замечаний).
          // Проверяем узел КАЖДОЙ строки отдельно, а не только первой - иначе строки
          // за месяцы с другим узлом либо попадут не в тот филиал, либо задвоятся
          // при обработке в п.3 ниже (там узел проверяется корректно, по строке).
          const rowsForThisFilial = facilityRows.filter((row: any) => {
            const rowNodeId = row.id_eco_heat_node;
            return filialData.nodes[rowNodeId] && !selectedNodes.includes(rowNodeId);
          });
          if (rowsForThisFilial.length === 0) continue;

          for (const row of rowsForThisFilial) {
            result.push({
              facility_name: `Объект: ${row.facility_name || this.getFacilityName(facilityId)}`,
              month: row.month,
              imbalance: row.imbalance ?? 0,
              imbalance_steam: row.imbalance_steam ?? 0,
              imbalance_water: row.imbalance_water ?? 0,
              system_water: row.system_water ? { ...row.system_water } : {},
              steam: row.steam ? { ...row.steam } : {},
              display_order: 4
            });
          }
        }
      }
    }

    // 2. Обрабатываем выбранные узлы (которые не входят в выбранные филиалы)
    if (selectedNodes.length > 0) {
      for (const nodeId of selectedNodes) {
        // Проверяем, не обработан ли уже этот узел как часть филиала
        const isPartOfSelectedFilial = selectedFilials.some((filialId: number) => {
          const filialData = tree?.[filialId];
          return filialData?.nodes?.[nodeId];
        });
        
        if (isPartOfSelectedFilial) continue; // Пропускаем, если узел уже обработан как часть филиала
        
        const nodeName = this.getNodeName(nodeId);
        const nodeRows = this.service.balance.filter((row: any) => row.id_eco_heat_node === nodeId);
        
        // Показываем агрегированную запись узла (агрегируем по ВСЕМ объектам узла)
        const aggregated = this.aggregateRowsByMonth(nodeRows);
        for (const [month, data] of Object.entries(aggregated)) {
          result.push({
            facility_name: `ТУ: ${nodeName}`,
            month,
            ...data,
            display_order: 3
          });
        }
        
        // Показываем объекты из selectionReal.facilities, которые входят в этот узел
        const nodeFacilities = selectedFacilities.filter((facilityId: number) => {
          return nodeRows.some((row: any) => row.id_eco_facility === facilityId);
        });

        for (const facilityId of nodeFacilities) {
          const facilityRows = nodeRows.filter((row: any) => row.id_eco_facility === facilityId);
          for (const row of facilityRows) {
            result.push({
              facility_name: `Объект: ${row.facility_name || this.getFacilityName(facilityId)}`,
              month: row.month,
              imbalance: row.imbalance ?? 0,
              imbalance_steam: row.imbalance_steam ?? 0,
              imbalance_water: row.imbalance_water ?? 0,
              system_water: row.system_water ? { ...row.system_water } : {},
              steam: row.steam ? { ...row.steam } : {},
              display_order: 4
            });
          }
        }
      }
    }

    // 3. Обрабатываем выбранные объекты (которые не входят в выбранные узлы или филиалы)
    if (selectedFacilities.length > 0) {
      for (const facilityId of selectedFacilities) {
        const facilityRows = this.service.balance.filter((row: any) => row.id_eco_facility === facilityId);
        
        for (const row of facilityRows) {
          // Проверяем, не обработан ли уже этот объект как часть узла или филиала
          const nodeId = row.id_eco_heat_node;
          const isPartOfSelectedNode = selectedNodes.includes(nodeId);
          const isPartOfSelectedFilial = selectedFilials.some((filialId: number) => {
            const filialData = tree?.[filialId];
            return filialData?.nodes?.[nodeId];
          });
          
          // Если объект входит в выбранный узел или филиал, пропускаем (уже обработан выше)
          if (isPartOfSelectedFilial || isPartOfSelectedNode) continue;
          
          result.push({
            facility_name: `Объект: ${row.facility_name || this.getFacilityName(facilityId)}`,
            month: row.month,
            imbalance: row.imbalance ?? 0,
            imbalance_steam: row.imbalance_steam ?? 0,
            imbalance_water: row.imbalance_water ?? 0,
            system_water: row.system_water ? { ...row.system_water } : {},
            steam: row.steam ? { ...row.steam } : {},
            display_order: 4
          });
        }
      }
    }

    // 4. Обрабатываем ПАО ТПлюс (если выбран)
    if (this.selectionReal?.t_plus === true) {
      // Агрегируем данные по ВСЕМ объектам из баланса
      const allRows = this.service.balance;
      const aggregated = this.aggregateRowsByMonth(allRows);
      for (const [month, data] of Object.entries(aggregated)) {
        result.push({
          facility_name: 'ПАО "Т Плюс"',
          month,
          ...data,
          display_order: 1
        });
      }
    }

    // Сортируем по display_order и месяцу
    result.sort((a, b) => {
      if (a.display_order !== b.display_order) {
        return a.display_order - b.display_order;
      }
      const monthOrder = this.periodOrder[a.month] ?? 999;
      const monthOrderB = this.periodOrder[b.month] ?? 999;
      return monthOrder - monthOrderB;
    });

    return result;
  }

  getTranformedDataGridBalanceCompare(): any {
    if (!this.service.balanceCompare || this.service.balanceCompare.length === 0) {
      return [];
    }

    if (!this.selectionReal || (!this.selectionReal.t_plus && !this.selectionReal.filials?.length && !this.selectionReal.nodes?.length && !this.selectionReal.facilities?.length)) {
      return [];
    }

    const result: any[] = [];
    const tree = this.ecoService.filialNodesFacilitiesTree;
    const selectedFilials = this.selectionReal?.filials || [];
    const selectedNodes = this.selectionReal?.nodes || [];
    const selectedFacilities = this.selectionReal?.facilities || [];

    // 1. Обрабатываем выбранные филиалы
    if (selectedFilials.length > 0) {
      for (const filialId of selectedFilials) {
        const filialName = this.getFilialName(filialId);
        
        // Находим все узлы этого филиала
        const filialData = tree?.[filialId];
        if (!filialData || !filialData.nodes) continue;
        
        // Собираем все объекты всех узлов филиала для агрегации
        const filialRows: any[] = [];
        for (const nodeIdStr in filialData.nodes) {
          const nodeId = Number(nodeIdStr);
          const nodeRows = this.service.balanceCompare.filter((row: any) => row.id_eco_heat_node === nodeId);
          filialRows.push(...nodeRows);
        }
        
        // Агрегируем по месяцам и показываем агрегированную запись филиала
        const aggregated = this.aggregateRowsByMonth(filialRows);
        for (const [month, data] of Object.entries(aggregated)) {
          result.push({
            facility_name: `Филиал: ${filialName}`,
            month,
            ...data,
            display_order: 2
          });
        }

        // Обрабатываем узлы из selectionReal.nodes, которые входят в этот филиал
        for (const nodeId of selectedNodes) {
          if (!filialData.nodes[nodeId]) continue; // Узел не входит в этот филиал
          
          const nodeName = this.getNodeName(nodeId);
          const nodeRows = this.service.balanceCompare.filter((row: any) => row.id_eco_heat_node === nodeId);
          
          // Показываем агрегированную запись узла (по всем объектам)
          const nodeAggregated = this.aggregateRowsByMonth(nodeRows);
          for (const [month, data] of Object.entries(nodeAggregated)) {
            result.push({
              facility_name: `ТУ: ${nodeName}`,
              month,
              ...data,
              display_order: 3
            });
          }

          // Показываем объекты из selectionReal.facilities, которые входят в этот узел
          const nodeFacilities = selectedFacilities.filter((facilityId: number) => {
            return nodeRows.some((row: any) => row.id_eco_facility === facilityId);
          });

          for (const facilityId of nodeFacilities) {
            const facilityRows = nodeRows.filter((row: any) => row.id_eco_facility === facilityId);
            for (const row of facilityRows) {
              result.push({
                facility_name: `Объект: ${row.facility_name || this.getFacilityName(facilityId)}`,
                month: row.month,
                imbalance: row.imbalance ?? 0,
                imbalance_steam: row.imbalance_steam ?? 0,
                imbalance_water: row.imbalance_water ?? 0,
                system_water: row.system_water ? { ...row.system_water } : {},
                steam: row.steam ? { ...row.steam } : {},
                display_order: 4
              });
            }
          }
        }

        // Обрабатываем объекты из selectionReal.facilities, которые входят в этот филиал, но не в выбранные узлы
        for (const facilityId of selectedFacilities) {
          const facilityRows = this.service.balanceCompare.filter((row: any) => row.id_eco_facility === facilityId);
          if (facilityRows.length === 0) continue;

          const nodeId = facilityRows[0].id_eco_heat_node;
          // Проверяем, что объект входит в этот филиал
          if (!filialData.nodes[nodeId]) continue;
          // Проверяем, что узел не выбран (иначе объект уже обработан выше)
          if (selectedNodes.includes(nodeId)) continue;

          for (const row of facilityRows) {
            result.push({
              facility_name: `Объект: ${row.facility_name || this.getFacilityName(facilityId)}`,
              month: row.month,
              imbalance: row.imbalance ?? 0,
              imbalance_steam: row.imbalance_steam ?? 0,
              imbalance_water: row.imbalance_water ?? 0,
              system_water: row.system_water ? { ...row.system_water } : {},
              steam: row.steam ? { ...row.steam } : {},
              display_order: 4
            });
          }
        }
      }
    }

    // 2. Обрабатываем выбранные узлы (которые не входят в выбранные филиалы)
    if (selectedNodes.length > 0) {
      for (const nodeId of selectedNodes) {
        // Проверяем, не обработан ли уже этот узел как часть филиала
        const isPartOfSelectedFilial = selectedFilials.some((filialId: number) => {
          const filialData = tree?.[filialId];
          return filialData?.nodes?.[nodeId];
        });
        
        if (isPartOfSelectedFilial) continue; // Пропускаем, если узел уже обработан как часть филиала
        
        const nodeName = this.getNodeName(nodeId);
        const nodeRows = this.service.balanceCompare.filter((row: any) => row.id_eco_heat_node === nodeId);
        
        // Показываем агрегированную запись узла (агрегируем по ВСЕМ объектам узла)
        const aggregated = this.aggregateRowsByMonth(nodeRows);
        for (const [month, data] of Object.entries(aggregated)) {
          result.push({
            facility_name: `ТУ: ${nodeName}`,
            month,
            ...data,
            display_order: 3
          });
        }
        
        // Показываем объекты из selectionReal.facilities, которые входят в этот узел
        const nodeFacilities = selectedFacilities.filter((facilityId: number) => {
          return nodeRows.some((row: any) => row.id_eco_facility === facilityId);
        });

        for (const facilityId of nodeFacilities) {
          const facilityRows = nodeRows.filter((row: any) => row.id_eco_facility === facilityId);
          for (const row of facilityRows) {
            result.push({
              facility_name: `Объект: ${row.facility_name || this.getFacilityName(facilityId)}`,
              month: row.month,
              imbalance: row.imbalance ?? 0,
              imbalance_steam: row.imbalance_steam ?? 0,
              imbalance_water: row.imbalance_water ?? 0,
              system_water: row.system_water ? { ...row.system_water } : {},
              steam: row.steam ? { ...row.steam } : {},
              display_order: 4
            });
          }
        }
      }
    }

    // 3. Обрабатываем выбранные объекты (которые не входят в выбранные узлы или филиалы)
    if (selectedFacilities.length > 0) {
      for (const facilityId of selectedFacilities) {
        const facilityRows = this.service.balanceCompare.filter((row: any) => row.id_eco_facility === facilityId);
        
        for (const row of facilityRows) {
          // Проверяем, не обработан ли уже этот объект как часть узла или филиала
          const nodeId = row.id_eco_heat_node;
          const isPartOfSelectedNode = selectedNodes.includes(nodeId);
          const isPartOfSelectedFilial = selectedFilials.some((filialId: number) => {
            const filialData = tree?.[filialId];
            return filialData?.nodes?.[nodeId];
          });
          
          // Если объект входит в выбранный узел или филиал, пропускаем (уже обработан выше)
          if (isPartOfSelectedFilial || isPartOfSelectedNode) continue;
          
          result.push({
            facility_name: `Объект: ${row.facility_name || this.getFacilityName(facilityId)}`,
            month: row.month,
            imbalance: row.imbalance ?? 0,
            imbalance_steam: row.imbalance_steam ?? 0,
            imbalance_water: row.imbalance_water ?? 0,
            system_water: row.system_water ? { ...row.system_water } : {},
            steam: row.steam ? { ...row.steam } : {},
            display_order: 4
          });
        }
      }
    }

    // 4. Обрабатываем ПАО ТПлюс (если выбран)
    if (this.selectionReal?.t_plus === true) {
      // Агрегируем данные по ВСЕМ объектам из баланса сравнения
      const allRows = this.service.balanceCompare;
      const aggregated = this.aggregateRowsByMonth(allRows);
      for (const [month, data] of Object.entries(aggregated)) {
        result.push({
          facility_name: 'ПАО "Т Плюс"',
          month,
          ...data,
          display_order: 1
        });
      }
    }

    // Сортируем по display_order и месяцу
    result.sort((a, b) => {
      if (a.display_order !== b.display_order) {
        return a.display_order - b.display_order;
      }
      const monthOrder = this.periodOrder[a.month] ?? 999;
      const monthOrderB = this.periodOrder[b.month] ?? 999;
      return monthOrder - monthOrderB;
    });

    return result;
  }

  empty() {
  }

  onContentReady() {
    if (this.readyCtr < this.widgetCount) {
      this.readyCtr++;
    }
    if (this.readyCtr === this.widgetCount && this.readyCtr > 1) {
      this.readyCtr++;
      setTimeout(() => this.initScrollable(), 200);
    }
  }

  initScrollable() {
    this.cleanupScrollHandlers();
    
    if (!this.balanceGrid) {
      return;
    }

    const grids: Array<{ scrollable: any; name: string }> = [];
    
    const mainScrollable = this.balanceGrid.getScrollable();
    if (mainScrollable) {
      grids.push({ scrollable: mainScrollable, name: 'main' });
    }

    if (this.balanceCompareGrid) {
      const compareScrollable = this.balanceCompareGrid.getScrollable();
      if (compareScrollable) {
        grids.push({ scrollable: compareScrollable, name: 'compare' });
      }
    }

    if (this.balanceDeviationGrid) {
      const deviationScrollable = this.balanceDeviationGrid.getScrollable();
      if (deviationScrollable) {
        grids.push({ scrollable: deviationScrollable, name: 'deviation' });
      }
    }

    if (grids.length < 2) {
      return;
    }

    let scrollTimeout: any = null;
    
    grids.forEach(({ scrollable, name }, index) => {
      const handler = (e: any) => {
        if (this.isScrolling) {
          return;
        }

        this.isScrolling = true;

        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }

        scrollTimeout = setTimeout(() => {
          grids.forEach(({ scrollable: targetScrollable, name: targetName }, targetIndex) => {
            if (targetIndex !== index && targetScrollable) {
              try {
                targetScrollable.scrollTo(e.scrollOffset);
              } catch (err) {
                console.warn(`Ошибка синхронизации скролла ${name} -> ${targetName}:`, err);
              }
            }
          });

          this.isScrolling = false;
        }, 16);
      };

      scrollable.on("scroll", handler);
      this.scrollHandlers.push(() => scrollable.off("scroll", handler));
    });

    this.scrollSyncEnabled = true;
  }

  private cleanupScrollHandlers() {
    this.scrollHandlers.forEach(cleanup => {
      try {
        cleanup();
      } catch (err) {
        console.warn('Ошибка при очистке обработчика скролла:', err);
      }
    });
    this.scrollHandlers = [];
    this.scrollSyncEnabled = false;
    this.isScrolling = false;
  }

  getLoad() {
    this.gropedObj = [];
    this.cleanupScrollHandlers();
    
    this.readyCtr = 0;
    this.widgetCount = this.showCompareCut ? 2 : 1;
    if (this.service.current.show_deviation) {
      this.widgetCount++;
    }

    this.service.getWithFilter();

    this.initColumns();
    this.initGroupedColumns();

    setTimeout(() => {
      this.showLoadIndicator = false;
    }, 2000);
  }

  giveName(names: any) {
    this.cutNames = names;
  }

  listAnalysis(notEmpty: boolean) {
    this.showPlug = notEmpty;
  }

  analyzeFilterSelected(selected: boolean) {
    this.filtersSelected = selected
  }

  async exportBalance() {
  const workbook = new Workbook();
  
  if (this.balanceGrid) {
    const ws1 = workbook.addWorksheet(this.cutNames.name || 'Main');
    await exportDataGrid({
      worksheet: ws1,
      component: this.balanceGrid,
      topLeftCell: { row: 1, column: 1 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (!excelCell) return;
        if (this.service.current.grouping === Grouping.BY_PERIOD && 
            gridCell?.rowType === 'data' && 
            excelCell?.fullAddress.col === 1) {
          excelCell.font = { bold: true };
        }
        setAlternatingRowsBackground(gridCell, excelCell, 1);
        this.customizeImbalanceCell(gridCell, excelCell, 1);
      },
    });
  }

  if (this.showCompareCut && this.balanceCompareGrid) {
    const ws2 = workbook.addWorksheet(this.cutNames.secondary || 'Compare');
    await exportDataGrid({
      worksheet: ws2,
      component: this.balanceCompareGrid,
      topLeftCell: { row: 1, column: 1 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (!excelCell) return;
        if (this.service.current.grouping === Grouping.BY_PERIOD && 
            gridCell?.rowType === 'data' && 
            excelCell?.fullAddress.col === 1) {
          excelCell.font = { bold: true };
        }
        setAlternatingRowsBackground(gridCell, excelCell, 1);
        this.customizeImbalanceCell(gridCell, excelCell, 1);
      },
    });
  }

  if (this.service.current.show_deviation && this.balanceDeviationGrid) {
    const ws3 = workbook.addWorksheet('Отклонения');
    await exportDataGrid({
      worksheet: ws3,
      component: this.balanceDeviationGrid,
      topLeftCell: { row: 1, column: 1 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (!excelCell) return;
        setAlternatingRowsBackground(gridCell, excelCell, 1);
        this.customizeImbalanceCell(gridCell, excelCell, 1);
      },
    });
  }

  workbook.xlsx.writeBuffer().then((buffer) => {
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `Физический_баланс_${this.cutNames.name}${this.showCompareCut ? ('_' + this.cutNames.secondary) : ''}${this.service.current.show_deviation ? '_отклонение' : ''}.xlsx`
    );
  });
}

private customizeImbalanceCell(gridCell: any, excelCell: any, leftColumn: number) {
  if (gridCell?.column?.dataField === 'imbalance' && gridCell?.value) {
    let cellColor;
    if (gridCell.rowType === 'groupFooter') {
      cellColor = "ffa6a3";
    } else {
      cellColor = (excelCell.fullAddress.row % 2 === 0) ? 'ffcbc8' : 'ffe7e5';
    }
    prettyCell(excelCell, { cellColor, fontColor: '000000' });
  } else if (this.service.current.grouping === Grouping.BY_PERIOD && 
             gridCell?.rowType === 'group' &&
             gridCell?.column?.dataField === 'imbalance' && 
             gridCell.column?.dataField && 
             excelCell.value) {
    prettyCell(excelCell, { cellColor: "ffa6a3", fontColor: '000000' });
  }
}

  private getCommonSummary(prefix: string, showInGroupFooter: boolean = false): any[] {
    return ['ok', 'hn', 'purchase_vendors', 'loss_total', 'tp', 'tso_p', 'kp', 'useful'].map( field => {
      return {
        column: prefix + "." + field,
        valueFormat: {
          type: "fixedPoint",
          precision: this.precisionValue
        },
        summaryType: "sum",
        showInGroupFooter,
        alignByColumn: true,
        displayFormat: '{0}'
      }
    });
  }

  private getCommonColumns(prefix: string): any[] {
    let data = [
      {
        dataField: `${prefix}.ok`,
        dataType: "number",
        format: "number",
        caption: "Отпуск с коллекторов",
        allowSorting: false,
      },
      {
        dataField: `${prefix}.hn`,
        dataType: "number",
        format: "number",
        caption: "Хоз. нужды",
        allowSorting: false,
      },
      {
        dataField: `${prefix}.purchase_vendors`,
        dataType: "number",
        format: "number",
        caption: "Покупка со стороны",
        allowSorting: false,
      },
      {
        caption: "Потери",
        columns: [
          {
            dataField: `${prefix}.loss_total`,
            dataType: "number",
            format: "number",
            caption: "Итого",
            allowSorting: false,
          },
          {
            dataField: `${prefix}.tp`,
            dataType: "number",
            format: "number",
            caption: "Тех. потери",
            allowSorting: false,
          },
          {
            dataField: `${prefix}.tso_p`,
            dataType: "number",
            format: "number",
            caption: "Потери ТСО",
            allowSorting: false,
          },
          {
            dataField: `${prefix}.kp`,
            dataType: "number",
            format: "number",
            caption: "Ком потери",
            cssClass: `${prefix}_kp`,
            allowSorting: false,
          },
        ]
      },
      {
        dataField: `${prefix}.useful`,
        dataType: "number",
        format: "number",
        caption: "Полезный отпуск конечным потребителям",
        cssClass: `${prefix}_useful`,
        allowSorting: false,
      },
    ];
    if(this.on_display_internal_revolutions) {
      data.splice(3, 0, {
        dataField: `${prefix}.purchase_vno_vgo`,
        dataType: "number",
        format: "number",
        caption: "Покупка по ВНО и ВГО",
        allowSorting: false,
        visibleIndex: 3
      } as any)
      data.push({
        dataField: `${prefix}.sale_vno_vgo`,
        dataType: "number",
        format: "number",
        caption: "Отпуск по ВНО и ВГО",
        allowSorting: false,
      })
    }
    return data;
  }

  private periodOrder: Record<string, number> = {
    january: 1,
    february: 2,
    march: 3,
    april: 4,
    may: 5,
    june: 6,
    july: 7,
    august: 8,
    september: 9,
    october: 10,
    november: 11,
    december: 12,
    a_month: 13,
    wane_a_month: 14,
    two_months: 15,
    wane_two_months: 16,
    three_months: 17,
    wane_three_months: 18,
    first_quarter: 19,
    four_months: 20,
    wane_four_months: 21,
    five_months: 22,
    wane_five_months: 23,
    six_months: 24,
    wane_six_months: 25,
    second_quarter: 26,
    first_half: 27,
    seven_months: 28,
    wane_seven_months: 29,
    eight_months: 30,
    wane_eight_months: 31,
    nine_months: 32,
    wane_nine_months: 33,
    third_quarter: 34,
    ten_months: 35,
    wane_ten_months: 36,
    eleven_months: 37,
    wane_eleven_months: 38,
    twelve_months: 39,
    wane_twelve_months: 40,
    thourth_quarter: 41,
    second_half: 42,
    year: 43
  };

  private initColumns() {
    this.currentGrouping = this.service.current.grouping;
    let columnsLocal: any[] = [];
    if(this.currentGrouping === Grouping.BY_FACILITY){
      columnsLocal = [
        {
          dataField: "facility_name",
          caption: "Объект",
          width: 270,
          groupIndex: 0,
          sortOrder: 'asc',
          allowSorting: true,
          calculateGroupValue: (row: any) => {
            // Для сортировки групп используем display_order
            // Порядок: 1 - Групповые объекты, 2 - Филиалы, 3 - Узлы, 4 - Объекты
            const order = row?.display_order ?? 999;
            const name = row?.facility_name ?? "";
            // Возвращаем строку с padding для правильной сортировки групп
            // Важно: order должен быть первым для правильной сортировки
            // Используем формат: "001_название" для правильной лексикографической сортировки
            return `${String(order).padStart(3, '0')}_${name}`;
          },
          calculateDisplayValue: (row: any) => {
            // Возвращаем реальное название без префикса display_order
            return row?.facility_name || '';
          },
          calculateSortValue: (row: any) => {
            // Сортируем по display_order, затем по названию
            // Порядок: 1 - Групповые объекты, 2 - Филиалы, 3 - Узлы, 4 - Объекты
            const order = row?.display_order ?? 999;
            const name = row?.facility_name?.toLowerCase() ?? "";
            // Возвращаем строку с padding для правильной сортировки
            // Важно: order должен быть первым для правильной сортировки
            return `${String(order).padStart(3, '0')}_${name}`;
          },
          groupCellTemplate: (cellElement: any, cellInfo: any) => {
            // Используем displayValue если доступен, иначе извлекаем из value
            const displayValue = cellInfo.displayValue || cellInfo.value || '';
            // Если значение содержит префикс с display_order, извлекаем реальное название
            const actualName = displayValue.includes('_') && /^\d{3}_/.test(displayValue) 
              ? displayValue.split('_').slice(1).join('_') 
              : displayValue;
            cellElement.innerText = actualName || '';
          }
        }
      ]
      
      columnsLocal = columnsLocal.concat([
        {
          dataField: "month",
          dataType: "string",
          caption: "Период",
          width:200,
          lookup: {
            dataSource: DictsCacheService.periods,
            valueExpr: "name",
            displayExpr: "display",
          },
          sortOrder: 'asc',
          allowSorting: true,
          calculateSortValue: (data: any) => {
            const value = String(data?.month ?? "").toLowerCase();
            return this.periodOrder[value] ?? Number.POSITIVE_INFINITY;
          },
          customizeText: function (cellInfo: any) {
            return cellInfo.valueText.split("_").pop();
          },
        },
        {
          caption: 'СЕТЕВАЯ ВОДА, тыс.Гкал',
          columns: this.getCommonColumns('system_water'),
          name: 'water'
        },
        {
          caption: 'ПАР, тыс.Гкал',
          columns: this.getCommonColumns('steam'),
          name: 'steam'
        },
        
        {
          dataField: "imbalance_water",
          dataType: "number",
          // format: format5DigitsVariant,
          caption: "Небаланс по сетевой воде, тыс.Гкал",
          cssClass: 'imbalance_water_cell',
          allowSorting: false,
        },
        {
          dataField: "imbalance_steam",
          dataType: "number",
          // format: format5DigitsVariant,
          caption: "Небаланс по пару, тыс.Гкал",
          cssClass: 'imbalance_steam_cell',
          allowSorting: false,
        },
        {
          dataField: "imbalance",
          dataType: "number",
          // format: format5DigitsVariant,
          caption: "Небаланс, тыс.Гкал",
          cssClass: 'imbalance_cell',
          allowSorting: false,
        }
      ])
    } else {
      columnsLocal = [
        {
          dataField: "facility_name",
          caption: "Объект",
          width: 270,
          sortOrder: 'asc',
          calculateSortValue: (row: any) => {
            // Сортируем по display_order, затем по названию
            // Порядок: 1 - Групповые объекты, 2 - Филиалы, 3 - Узлы, 4 - Объекты
            const order = row?.display_order ?? 999;
            const name = row?.facility_name?.toLowerCase() ?? "";
            // Используем строку с padding для правильной сортировки: сначала по order, потом по name
            return `${String(order).padStart(3, '0')}_${name}`;
          }
        }
      ]
      
      columnsLocal = columnsLocal.concat([
        {
          dataField: "month",
          dataType: "string",
          caption: "Период",
          groupIndex: 0,
          width:200,
          lookup: {
            dataSource: DictsCacheService.periods,
            valueExpr: "name",
            displayExpr: "display",
          },
          sortOrder: 'asc',
          allowSorting: true,
          calculateGroupValue: function (data: any) {
            const value = this.calculateCellValue(data);
            const sort = this.lookup.items.find((x: any) => x.name === value);
            return `${letters[sort.months]}_${sort.display}`;
          },
          customizeText: function (cellInfo: any) {
            return cellInfo.valueText.split("_").pop();
          },
        },
        {
          caption: 'СЕТЕВАЯ ВОДА, тыс.Гкал',
          columns: this.getCommonColumns('system_water'),
          name: 'water'
        },
        {
          caption: 'ПАР, тыс.Гкал',
          columns: this.getCommonColumns('steam'),
          name: 'steam'
        },
        {
          dataField: "imbalance_water",
          dataType: "number",
          // format: format5DigitsVariant,
          caption: "Небаланс по сетевой воде, тыс.Гкал",
          cssClass: 'imbalance_water_cell',
          allowSorting: false,
        },
        {
          dataField: "imbalance_steam",
          dataType: "number",
          // format: format5DigitsVariant,
          caption: "Небаланс по пару, тыс.Гкал",
          cssClass: 'imbalance_steam_cell',
          allowSorting: false,
        },
        {
          dataField: "imbalance",
          dataType: "number",
          // format: format5DigitsVariant,
          caption: "Небаланс, тыс.Гкал",
          cssClass: 'imbalance_cell',
          allowSorting: false,
        },
      ])
    }

    this.columns = columnsLocal
  }

  private initGroupedColumns() {
    let columnsLocal: any[] = [];

    columnsLocal = [
      {
        dataField: `title`,
        dataType: "string",
        caption: "Объект",
        width: 270,
        fixed: 'left',
        sortOrder: "asc",
        allowSorting: true,
        calculateSortValue: (row: any) => {
          // Сортируем по display_order, затем по названию
          // Порядок: 1 - Групповые объекты, 2 - Филиалы, 3 - Узлы, 4 - Объекты
          const order = row?.display_order ?? 999;
          const name = row?.facility_name?.toLowerCase() ?? row?.title?.toLowerCase() ?? "";
          // Используем строку с padding для правильной сортировки: сначала по order, потом по name
          // Важно: order должен быть первым для правильной сортировки
          return `${String(order).padStart(3, '0')}_${name}`;
        },
      },
      {
        dataField: "month",
        dataType: "string",
        caption: "Период",
        width: 200,
        lookup: {
          dataSource: DictsCacheService.periods,
          valueExpr: 'name',
          displayExpr: 'display'
        },
        sortOrder: 'asc',
        allowSorting: true,
        calculateSortValue: function (data: any) {
          const value = this.calculateCellValue(data);
          const items = (this.lookup && this.lookup.items) ? this.lookup.items : [];
          const sort = items.find((x: any) => x.name === value);
          return (sort && sort.months) ? sort.months : Number.POSITIVE_INFINITY;
        },
      },
      {
        caption: 'СЕТЕВАЯ ВОДА, тыс.Гкал',
        columns: this.getCommonColumns('system_water')
      },
      {
        caption: 'ПАР, тыс.Гкал',
        columns: this.getCommonColumns('steam')
      },
      {
        caption: 'Сводные данные',
        isBand: true,
        columns: [
          {
            dataField: 'imbalance_water',
            caption: 'Небаланс (сетевая вода)',
            dataType: 'number',
            format: { type: "fixedPoint", precision: this.precisionValue },
            width: 120,
            cssClass: 'imbalance',
            allowSorting: false,
          },
          {
            dataField: 'imbalance_steam',
            caption: 'Небаланс  (пар)',
            dataType: 'number',
            format: { type: "fixedPoint", precision: this.precisionValue },
            width: 120,
            cssClass: 'imbalance',
            allowSorting: false,
          },
          {
            dataField: 'imbalance',
            caption: 'Небаланс',
            dataType: 'number',
            format: { type: "fixedPoint", precision: this.precisionValue },
            width: 120,
            cssClass: 'imbalance',
            allowSorting: false,
          }
        ]
      }
    ];

    this.groupedColumns = columnsLocal;

    setTimeout(() => {
      const scrollViewInstance = (this.$refs.balance_scroll_view as any).instance;
      if (scrollViewInstance) {
        scrollViewInstance.update();
      }
    }, 500);
  }

  private customizeCell(e: CellPreparedEvent) {
    const imbalanceFields = ['imbalance', 'imbalance_water', 'imbalance_steam'];

    if (e.rowType === 'header') {
      e.cellElement.style.textAlign = 'center';

      const caption = e.column.caption || '';
      if (['СЕТЕВАЯ ВОДА, тыс.Гкал', 'ПАР, тыс.Гкал', 'Сводные данные'].includes(caption)) {
        e.cellElement.style.backgroundColor =
          caption === 'ПАР, тыс.Гкал' ? '#dbdbdb' : '#b4c7e7';
      }

      if (!e.cellElement.querySelector('.dx-datagrid-text-content') && caption) {
        const div = document.createElement('div');
        div.className = 'dx-datagrid-text-content';
        div.textContent = caption;
        e.cellElement.innerHTML = '';
        e.cellElement.appendChild(div);
      }

      return;
    }

    if (e.rowType === 'data') {
      const field = e.column.dataField;
      if (field && imbalanceFields.includes(field)) {
        const value = e.data && e.data[field];
        this.subscribeCellData(e, () => value);
        e.cellElement.style.backgroundColor = getImbalanceStyleColor('summary_data_common', value);
      }
      return;
    }

    if (e.rowType === 'group' || e.rowType === 'groupFooter') {
      const field = e.column.dataField;
      if (field && imbalanceFields.includes(field)) {
        if (field === 'imbalance' || field === 'imbalance_steam' || field === 'imbalance_water') {
          return;
        }

        let itemsArrayFunction: (e: any) => any[] = () => [];

        const hasNestedItems =
          e.data &&
          Array.isArray(e.data.items) &&
          e.data.items.length > 0 &&
          Array.isArray(e.data.items[0].items);

        if (e.rowType === 'group' && hasNestedItems) {
          itemsArrayFunction = function (e: any): any[] {
            const items = e.data.items;
            let result: any[] = [];
            for (let i = 0; i < items.length; i++) {
              const innerItems = items[i].items || [];
              result = result.concat(innerItems);
            }
            return result;
          };
        } else if (e.data && Array.isArray(e.data.items)) {
          itemsArrayFunction = (e: any) => e.data.items;
        }

        const items = itemsArrayFunction(e);
        const value = items.reduce(function (acc: number, val: any) {
          return acc + (val && val[field] ? val[field] : 0);
        }, 0);

        this.subscribeCellData(e, () => value);
        if (value) {
          e.cellElement.style.backgroundColor = getImbalanceStyleColor('summary_data_common', value);
        }
      }
      return;
    }
  }

  private subscribeCellData(e: any, calcMethod: Function) {
    const value = calcMethod(e);
    const formatted = format3DigitsVariant.format(value || 0.0);

    e.cellElement.innerHTML = '';

    const span = document.createElement('span');
    span.textContent = formatted;

    (FullNumberTooltip as any).bind(span, { value: value });

    e.cellElement.appendChild(span);

    const textContentElement = e.cellElement.querySelector('.dx-datagrid-text-content');
    if (textContentElement) {
      textContentElement.innerHTML = '';
      textContentElement.appendChild(span);
    } else {
      e.cellElement.appendChild(span);
    }
  }

  @Watch("current_cut")
  async changeCut() {
    if (!this.isLoad) return;
    const prevFilial: number | null = this.current_filial;
    const prevNode: number | null = this.current_node;
    const prevFacility: number | null = this.current_facility;
    if (this.current_cut) {
      await this.getFilialsTree();
      if (this.all_filials.some((f: any) => f.id === prevFilial)) {
        this.current_filial = prevFilial;
        if (this.all_filials_tree[`${prevFilial}`]?.some((n: any) => n.id === prevNode)) {
          this.current_node = prevNode;
          if (this.all_facilities?.some((f: any) => f.id === prevFacility)) {
            this.current_facility = prevFacility;
          } else {
            this.current_facility = null;
          }
        } else {
          this.current_node = null;
          this.current_facility = null;
        }
      } else {
        this.current_filial = null;
        this.current_node = null;
        this.current_facility = null;
      }
    } else {
      this.current_filial = null;
      this.current_node = null;
      this.current_facility = null;
    }
    this.saveFilters && this.saveFilters();
  }
}
